import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import "../../assets/css/kanban.css";
import CustomToast from '../../components/CustomToast';
import { Col, Row, Card, Container } from 'react-bootstrap';
export default function BoardSidebar({ visible, onHide, customColumns, boardName }) {
    const [tasks, setTasks] = useState({});
    const toastRef = useRef(null);

    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };
    useEffect(() => {
        const newTasks = {
            'To Do': [
                { id: '1', title: 'Sample Task' },
                { id: '2', title: 'Another Task' },
                { id: '3', title: 'Yet Another Task' }
            ],
            ...customColumns
                .filter(col => col.name !== 'To Do' && col.name !== 'Completed')
                .reduce((acc, col, idx) => {
                    const colName = col.name || `Column ${idx + 1}`;
                    acc[colName] = [];
                    return acc;
                }, {}),
            'Completed': [
                { id: '4', title: 'Completed Task' },
                { id: '5', title: 'Another Completed Task' }
            ],
        };
        setTasks(newTasks);
    }, [customColumns]);
    
    const onDragEnd = (result) => {
        const { source, destination } = result;

        // Drop outside any droppable
        if (!destination) return;

        const sourceCol = source.droppableId;
        const destCol = destination.droppableId;

        if (destCol === 'To Do') {
            showMessage('error', 'You cannot move a task back to To Do');
            return;
        }

        if (sourceCol === 'Completed') {
            showMessage('error', 'You cannot move tasks from Completed');
            return;
        }

        const isCompletedCol = (name) => ['Completed', 'Done'].includes(name);
        if (isCompletedCol(destCol)) {
            showMessage('error', 'Tasks must go through In Review and be approved before completing.');
            return;
        }

        const sourceTasks = Array.from(tasks[sourceCol]);
        const destTasks = Array.from(tasks[destCol]);

        const [movedTask] = sourceTasks.splice(source.index, 1);
        destTasks.splice(destination.index, 0, movedTask);

        setTasks({
            ...tasks,
            [sourceCol]: sourceTasks,
            [destCol]: destTasks,
        });
        showMessage('success', 'Task updated successfully');
    };


    const getColumns = () => {
        return customColumns.map((col, idx) => ({
            id: col.name || `Column ${idx + 1}`,
            title: col.name || `Column ${idx + 1}`,
            tasks: tasks[col.name || `Column ${idx + 1}`] || [],
            color: col.color || '#cccccc'
        }));
    };
    

    return (
        <Dialog
            visible={visible}
            position="right"
            onHide={onHide}
            style={{ width: 'auto', maxWidth: '98%' }}
            draggable={false}
            className="KanbanDialog"
        >
            <Container fluid>
                <Row className="mx-0">

                    {/*---Right_part--- */}
                    <Col lg={12} md={12} sm={12} className="p-0 right_partD">
                        <Card className="shadow-0 p-0">
                            <Card.Header className="px-0 border-0">
                                <h5>{boardName} Preview</h5>
                            </Card.Header>
                            <Card.Body className="px-0 pt-0">
                                <DragDropContext onDragEnd={onDragEnd}>
                                    <div className="d-flex gap-3 overflow-auto pb-3" style={{ minHeight: '70vh' }}>
                                        {getColumns().map((column) => (
                                            <Droppable droppableId={column.id} key={column.id}>
                                                {(provided) => (
                                                    <div
                                                        {...provided.droppableProps}
                                                        ref={provided.innerRef}
                                                        className="kanban-column d-flex flex-column"
                                                        style={{
                                                            minWidth: '280px',
                                                            maxHeight: '80vh',
                                                            background: '#f4f5f7',
                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            flexShrink: 0,
                                                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                                        }}
                                                    >
                                                        <div
                                                            className="column-header p-2 text-white mb-2"
                                                            style={{
                                                                background: column.color,
                                                                borderRadius: '6px',
                                                                fontWeight: 'bold',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            {column.title}
                                                        </div>
                                                        <div style={{ overflowY: 'auto', flexGrow: 1 }}>
                                                            {column.tasks.map((task, index) => (
                                                                <Draggable draggableId={task.id} index={index} key={task.id}>
                                                                    {(provided) => (
                                                                        <div
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            className="p-2 mb-2 bg-white rounded shadow-sm border"
                                                                            style={{
                                                                                ...provided.draggableProps.style,
                                                                                userSelect: 'none',
                                                                                cursor: 'grab'
                                                                            }}
                                                                        >
                                                                            <div className="d-flex justify-content-end align-items-center mb-3">
                                                                                <small><i className="pi pi-comments"></i> 2</small>
                                                                                <small><i className="pi pi-paperclip"></i> 1</small>
                                                                                <small><i className="pi pi-check-square"> </i>0/1</small>
                                                                                <small><i className="pi pi-pencil"></i></small>
                                                                            </div>

                                                                            {task.title}

                                                                            <div className="d-flex justify-content-between align-items-center border-top mt-2 pt-2">
                                                                                <small><i className="pi pi-calendar"></i>7 Apr - 8 Apr</small>
                                                                                <AvatarGroup>
                                                                                    <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png" shape="circle" />
                                                                                    <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/asiyajavayant.png" shape="circle" />
                                                                                    <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/onyamalimba.png" shape="circle" />
                                                                                    <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/ionibowcher.png" shape="circle" />
                                                                                    <Avatar image="https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png" shape="circle" />
                                                                                </AvatarGroup>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                            {provided.placeholder}
                                                        </div>
                                                    </div>
                                                )}
                                            </Droppable>
                                        ))}
                                    </div>
                                </DragDropContext>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <CustomToast ref={toastRef} />
            </Container>

        </Dialog>
    );
}
